function scrollToRelatedColors() {
  var headerHeight = $('.layout-2.bottom-header').outerHeight();
  $('html, body').animate({ scrollTop: $('#related_colors').offset().top - headerHeight }, 'slow');
}

function scrollToRelatedProducts() {
  var headerHeight = $('.layout-2.bottom-header').outerHeight();
  $('html, body').animate({ scrollTop: $('#related-products').offset().top - headerHeight }, 'slow');
}

$(document).ready(function () {
  if ($('.video-product')) {
    $('.video-product').each((index) => {
      $('.video-product').get(index).play();
    });
  }

  try {
    var getvars = [];
    location.search.replace('?', '').split('&').forEach(function (val) {
      split = val.split("=", 2);
      getvars[split[0]] = split[1];
    });

    if (getvars["contact_posted"] == "true" && jQuery("[data-target='#myModal_trystore']") && $('.template-product')) {
      jQuery("[data-target='#myModal_trystore']").click();
    }

    if (getvars["contact_posted"] == "true" || getvars["getnotified"] == "true") {
      if (jQuery("[data-target='#myModal_notify']") && $('.template-product')) {
        jQuery("[data-target='#myModal_notify']").click();
      }
    }

    if (getvars["customer_posted"].indexOf("true") !== -1) {
      var headerHeight = $('.layout-2.bottom-header').outerHeight();
      $('html, body').animate({ scrollTop: $('#shopify-section-footer_ella_v').offset().top - headerHeight }, 'slow');
    }

  }
  catch (err) {
    console.log("La modale non è stata aperta perché: " + err.message);
  }

  /* Adding privacy checkbox to product reviews */

  function togglePrivacyDisplay() {
    if ($('.spr-form').css('display') == 'none') {
      $('.review-privacy-label').hide();
    } else {
      $('.review-privacy-label').show();
      $('.review-privacy-label').insertAfter($('.spr-form-review'));
    }
  }

  function checkPrivacy() {
    let checkbox = $('input[name="review-checkbox"]');
    if (!checkbox.prop('checked')) {
      return false;
    } else {
      return true;
    }
  }

  let panel_vertical = $('.panel.rte');

  panel_vertical.on('click', '.spr-button-primary[type="submit"]', function () {
    event.preventDefault();
    var is_checked = checkPrivacy();
    if (is_checked === true) {
      $('.new-review-form').submit();
      setTimeout(function () {
        if ($('.spr-form-message-success')) {
          $('.review-privacy-label').hide();
        }
      }, 200)
    } else {
      $('.review-privacy-label').addClass('sh-review-error');
    }
  });


  panel_vertical.on('click', '.spr-summary-actions-newreview', function () {
    togglePrivacyDisplay();
  });

  /*let checkbox_template = $('.review-privacy-label').clone();
  $('.panel-title').on('click', $('.spr-summary-actions-newreview'), function(){
    $('.spr-summary-actions-newreview').click(function(){
      checkbox_template.remove();
      $('form.new-review-form').append(checkbox_template);
      checkbox_template.css('display','block');
    })
  });

  $('.panel-title').on('click', $('.spr-button-primary[type="submit"]'), function(){
    $('.spr-button-primary[type="submit"]').click(function(event){
      event.preventDefault();
      $('form.new-review-form').append(checkbox_template);
      checkbox_template.css('display','block');
      $('.new-review-form').submit();
    })
  });*/


  function audioPlayer() {
    let video = $('.eye-category-video video');
    $('.eye-category-video .audio-player').click(function () {
      if ($('.eye-category-video-wrapper').hasClass('muted')) {
        video.each(function (index, item) {
          item.muted = false;
        })
        $('.eye-category-video-wrapper').removeClass('muted');
      } else {
        video.each(function (index, item) {
          item.muted = true;
        })
        $('.eye-category-video-wrapper').addClass('muted');
      }
    })
  } audioPlayer();
});

/* vDEV */
(() => {
    
  window.themeObj = {};
  
  window.themeObj.init = () => {
    const obj = window.themeObj;
    
    obj.templates.init();
    obj.sections.init();
  };
  
  window.themeObj.tools = {
    
    cookie: {
      get: (name) => {
        const value = `; ${document.cookie}`;
  
        if (document.cookie.includes(`; ${name}=`)) {
          const parts = value.split(`; ${name}=`);
          
          if (parts.length === 2) {
            return parts.pop().split(';').shift();
          }
        }
  
        return '';
      },
      
      set: (name, value, days = 365) => {
        var expires = '';
        
        //var days = 365;
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        
        const cookieText = `${name}=${value}; expires=${date.toUTCString()}; domain=.${window.location.hostname}; path=/`;
        document.cookie = cookieText;
      }
    }
  };
  
  window.themeObj.templates = {
    
    init: () => {
      const obj2 = window.themeObj.templates;

      if (document.body.classList.contains('template-product')) {
        obj2.product.init();
      }
    },

    product: {

      init: () => {
        const obj3 = window.themeObj.templates.product;
        
        new obj3.lensadvizor();
      },

      lensadvizor: class {

        constructor() {
          const obj3 = this;

          obj3.events();
        }

        events() {
          const obj3 = this;
          
          document.addEventListener('LensAdvizor:init:complete', () => {
            obj3.render();
          });
  
          document.addEventListener('LensAdvizor:variant:change', () => {
            obj3.render();
          });
        }
  
        render() {
          const obj3 = this;

          const button = document.getElementById('la-select-lenses-btn');
  
          if (!button) {
            return false;
          }
  
          button.classList.add('btn');
          button.classList.add('eo-button-primary');
        }
      }
    }
  };
  
  window.themeObj.sections = {
  
    init: () => {
      const obj2 = window.themeObj.sections;
  
      obj2.cartPopup();
      obj2.productGridItemColors();
      
      if (document.body.classList.contains('template-search') || document.body.classList.contains('template-collection')) {
        new obj2.sidebarFilters();
        
      } else if (document.body.classList.contains('template-product')) {
        obj2.productPopups();
      }
    },
    
    cartPopup: () => {
      const obj2 = window.themeObj.sections;

      document.addEventListener('theme:cart:openPopup', () => {
        const button = document.querySelector('.cartToggle');
        
        if (!button) {
          return false;
        }
  
        document.dispatchEvent(new CustomEvent('theme:cart:updateDropdown'));
      
        setTimeout(() => {
          button.click();
        }, 500);
      });
    },
    
    productGridItemColors: () => {
      const obj2 = this;

      class ProductGridItemColors extends HTMLElement {

        settings = {
          tag: this.getAttribute('data-tag')
        }

        constructor() {
          super();
          
          const obj3 = this;

          if (obj3.classList.contains('is-rendered')) {
            return false;
          }

          const query = `"${obj3.settings.tag}"`;
          const url = `${window.Shopify.routes.root}search?type=product&view=product-grid-item-colors&q=${encodeURIComponent(query)}`;

          fetch(url, {
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
          })
            .then(response => {
      
              if (!response.ok) {
                return false;
              }
      
              return response.json();
            })
            .then((response) => {
              obj3.classList.add('is-rendered');

              if (!response.product_colors) {
                return false;
              }

              obj3.textContent = response.product_colors;
            });
        }
      }
      
      customElements.define('product-grid-item-colors', ProductGridItemColors);   
    },
  
    loader: {
      
      show: () => {
        const loadingModal = document.querySelector('.loading-modal');
  
        if (loadingModal) {
          loadingModal.style.display = 'block';
        }
  
        setTimeout(() => {
          window.themeObj.sections.loader.hide();
        }, 2000);
      },
      
      hide: () => {
        const loadingModal = document.querySelector('.loading-modal');
  
        if (loadingModal) {
          loadingModal.style.display = 'none';
        }
      }
    },
      
    productsGrid: class {
  
      constructor() {
        const obj = this;
        
        obj.refreshItems();
      }
  
      refreshItems() {
        const obj = this;
        
        const eventName = 'theme:products:refresh'; 
        const event = new Event(eventName);
  
        document.body.addEventListener(eventName, () => {
          const items = document.querySelectorAll('.products-grid .grid-item > .product-item');
    
          if (items.length) {
            
            for (let i = 0; i < items.length; i++) {
              const item = items[i];
              obj.refreshItem(item, i);
            }
          }
        });
  
        if (/page=\d+/g.test(window.location.href)) {
          document.body.dispatchEvent(event);
        }
      }
  
      refreshItem(item, i) {
        const obj = this;
  
        const itemColors = item.querySelector('.product-colors[data-tag]');
  
        if (itemColors) {
  
          setTimeout(() => {
            const tag = itemColors.getAttribute('data-tag');
            obj.refreshItemColors(tag);
          }, (100 * i));
        }
      }
  
      refreshItemColors(tag) {
        const obj = this;
        
        const itemsColors = document.querySelectorAll(`.products-grid .grid-item > .product-item .product-colors[data-tag="${tag}"]`);
  
        if (itemsColors.length) {
  
          for (let i = 0; i < itemsColors.length; i++) {
            const itemColors = itemsColors[i];
            const url = `/search?type=product&view=json&q=${encodeURIComponent(tag)}`;
            
            fetch(url, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              }
            }).then((response) => response.json())
              .then((response) => {
                itemColors.removeAttribute('data-tag');
                
                const itemColorsCount = parseInt(response.results_count);
  
                if (itemColorsCount == 1) {
                  const itemColorsText = itemColors.getAttribute('data-text-color').replace(/\%count\%/, itemColorsCount);
                  itemColors.innerHTML = itemColorsText;
                  
                } else if (itemColorsCount > 1) {
                  const itemColorsText = itemColors.getAttribute('data-text-colors').replace(/\%count\%/, itemColorsCount);
                  itemColors.innerHTML = itemColorsText;
                
                } else {
                  itemColors.remove();
                }
            });
          }
        }
      }
    },
  
    productPopups: () => {
      const obj2 = this;
      
      class N8nForm extends HTMLElement {

        settings = {
          type: this.getAttribute('data-form-type'),
          form: this.querySelector('form'),
          button: this.querySelector('button[data-n8n-form--action="submit"]')
        }

        constructor() {
          super();
          
          const obj3 = this;

          obj3.events();
          
          obj3.variantsField();
          obj3.storesField();
        }

        events() {
          const obj3 = this;

          obj3.settings.form.addEventListener('submit', (event) => {
            event.preventDefault();
            event.stopPropagation();
            
            obj3.form__submit();
            
            return false;
          });

          obj3.settings.button.addEventListener('click', () => {
            obj3.form__submit();
          });
        }

        /* Field: Variants */
        variantsField() {
          const obj3 = this;

          const productForm__wrapper = document.querySelector('.product-shop');

          if (!productForm__wrapper) {
            return false;
          }
          
          const productForm = productForm__wrapper.querySelector('form');
           
          if (!productForm) {
            return false;
          }

          const productVariants = productForm__wrapper.querySelectorAll('#product-variants .swatch .swatch-element input[type="radio"][name="option-0"]');
          
          if (!productVariants.length) {
            return false;
          }
          
          productVariants.forEach((productVariant) => {

            productVariant.addEventListener('change', () => {
              const productVariant__sku = obj3.querySelector('[data-n8n-form--name="sku"]');

              if (productVariant__sku) {
                productVariant__sku.value = productVariant.getAttribute('data-variant-sku');
              }

              const productVariant__quantity = obj3.querySelector('[data-n8n-form--name="product_variant_qty"]');

              if (productVariant__quantity) {
                productVariant__quantity.value = parseInt(productVariant.getAttribute('data-variant-quantity'));

                const modalOpener = document.querySelector(`#add-to-cart-form input.btn[data-target="#productPopup--${obj3.settings.type}"]`);

                if (modalOpener) {
                  
                  if (productVariant__quantity.value > 0) {
                    modalOpener.removeAttribute('disabled');
                    
                  } else {
                    modalOpener.setAttribute('disabled', 'disabled');
                  }
                }
              }

              const productVariant__id = obj3.querySelector('[data-n8n-form--name="product_variant_id"]');

              if (productVariant__id) {
                productVariant__id.value = productForm__wrapper.querySelector('[name="id"]').value;
              }

              const productVariant__value = obj3.querySelector('[data-n8n-form--name="shopify_option1"]');

              if (productVariant__value) {
                productVariant__value.value = productVariant.value;
              }
              
              const productVariant__imageUrl = obj3.querySelector('[data-n8n-form--name="image_url"]');

              if (productVariant__imageUrl) {
                productVariant__imageUrl.value = productVariant.getAttribute('data-variant-image-url');
              }
            });
          });
        }
        /* /Field: Variants */

        /* Field: Stores */
        storesField() {
          const obj3 = this;

          $(`#productPopup--${obj3.settings.type}`).on('shown.bs.modal', () => {
            obj3.storesField__render();
          });
        }
        
        async storesField__render() {
          const obj3 = this;
          
          let items;

          const cookieItems = obj3.storesField__getCookieItems();

          if (cookieItems.length&& meta.product.vendor != 'Jacques Marie Mage') {
            items = cookieItems;
          
          } else {
            items = await obj3.storesField__getRemoteItems();
            if(meta.product.vendor == 'Jacques Marie Mage'){
              items = items.filter(i => ["RUC_0E"].includes(i.code));
            }

            if (items && items.length && meta.product.vendor != 'Jacques Marie Mage') {
              await obj3.storesField__setCookieItems(items);
            }
          }

          await obj3.storesField__renderByItems(items);
        }

        async storesField__renderByItems(items) {
          const obj3 = this;
          
          if (!items || !items.length) {
            return false;
          }

          let formField__nativeSelect = obj3.settings.form.querySelector('select[data-n8n-form--name="store"]');

          if (!formField__nativeSelect || formField__nativeSelect.classList.contains('is-rendered')) {
            return false;
          }

          formField__nativeSelect.classList.add('is-rendered');

          /* Availability */
          const productTags = JSON.parse(document.getElementById('product-json-tags').innerText);

          const formField__availability__match = formField__nativeSelect.getAttribute('data-availability-match');
          const formField__availability__notMatch = formField__nativeSelect.getAttribute('data-availability--not-match');

          const formField__availableInStore = obj3.settings.form.querySelector('input[name="contact[available_in_store]"]');
          /* /Availability */
          
          let itemI = 0;

          items.forEach((item) => {
            let itemElement;
            
            let item__availableInStore = false;
            let item__availability = formField__availability__notMatch;

            if (productTags.includes(item.code)) {
              item__availableInStore = true;
              item__availability = formField__availability__match;
            }
                
            const itemText = `${item.shop} - ${item__availability}`;

            /* Native select item */
            itemElement = document.createElement('option');
            itemElement.setAttribute('value', item.code);
            itemElement.setAttribute('data--available-in-store', item__availableInStore);
            if(item__availableInStore){
                itemElement.style.color='#00822c'//green
              }else{
                itemElement.style.color='#969696'//gray
              }
            
            itemElement.innerHTML = itemText;
            formField__nativeSelect.append(itemElement);
            /* Native select item */
          });

          formField__nativeSelect.addEventListener('change', () => {
            const formField__nativeSelect__option = formField__nativeSelect.options[formField__nativeSelect.selectedIndex];
            formField__availableInStore.value = formField__nativeSelect__option.getAttribute('data--available-in-store');
          });
        }
        
        storesField__getCookieItems() {
          const obj3 = this;
          
          const cookieId = 'shopify--n8n:stores';
          
          const itemsText = window.themeObj.tools.cookie.get(cookieId);
          let newItems = [];
    
          if (itemsText) {
            const items = JSON.parse(itemsText);
            
            for (let itemKey in items) {
              newItems.push({
                code: itemKey,
                shop: items[itemKey]
              });
            }
          }

          return newItems;
        }

        async storesField__setCookieItems(items) {
          const obj3 = this;

          let newItems = {};

          items.forEach((item) => {
            newItems[item.code] = item.shop;
          });
          
          const cookieId = 'shopify--n8n:stores';
          window.themeObj.tools.cookie.set(cookieId, JSON.stringify(newItems),1);
        }

        async storesField__getRemoteItems() {
          const obj3 = this;
          
          const formUrl = 'https://n8n.eye-oo.com/webhook/odoo/stores/try/get';

          return await fetch(formUrl)
            .then((response) => {

              if (!response.ok) {
                return false;
              }
              
              return response.json();
            })
              .then((response) => {
                return response;
              });
        }
        /* /Field: Stores */

        /* Form: Submit */
        async form__submit() {
          const obj3 = this;
          
          obj3.settings.button.setAttribute('disabled', 'disabled');

          if (obj3.settings.form.checkValidity()) {
            await obj3.n8n__submit();
            
          } else {
            obj3.settings.form.reportValidity();
            obj3.settings.button.removeAttribute('disabled');
          }
        }

        async n8n__submit() {
          const obj3 = this;
          
          obj3.settings.button.setAttribute('disabled', 'disabled');
          
          const formFields = obj3.settings.form.querySelectorAll('[data-n8n-form--name]');

          if (!formFields.length) {
            return false;
          }
          
          const formBody = new FormData();

          formFields.forEach((formField) => {
            formField.setAttribute('value', formField.value);

            const formFieldNewName = formField.getAttribute('data-n8n-form--name');
            formBody.set(formFieldNewName, formField.value)
          });

          const formUrl = obj3.getAttribute('data-form-url');
          const formMethod = 'post';

          fetch(formUrl, {
            method: formMethod,
            body: formBody
          })
            .then((response) => {
            
              if (!response.ok) {
                return false;
              }

              return response.json();
            })
            .then((response) => {
              
              if (!Array.isArray(response)) {
                obj3.settings.button.removeAttribute('disabled');
  
                return false;
              }

              return response;
            })
            .then((response) => {
              obj3.n8n__submitted(response);
            });
        }

        async n8n__submitted(items) {
          const obj3 = this;

          if (!items) {
            obj3.settings.button.removeAttribute('disabled');
            
            return false;
          }

          items.forEach((item) => {
            /* Alerts */
            const formAlerts = obj3.settings.form.querySelector('.n8n-form__alerts');
            formAlerts.innerHTML = '';
            
            if (item.message) {
              const itemElement = document.createElement('p');
              itemElement.classList.add('note');
              
              if (item.status == 'OK') {
                itemElement.classList.add('form-success');
                
              } else {
                itemElement.classList.add('form-error');
              }
              
              itemElement.innerHTML = item.message;
              
              formAlerts.append(itemElement);
              formAlerts.classList.remove('hide');

            } else {
              formAlerts.classList.add('hide');
            }
            /* /Alerts */
            
            /* Products */
            const formItems = obj3.querySelector('.n8n-form__products');
            formItems.innerHTML = '';

            if (item.status == 'KO' && item['products']) {
              
              item['products'].forEach((product) => {
                const itemElement = document.createElement('div');
                itemElement.innerHTML = `
                  <div class="n8n-form__product">
                    <div class="n8n-form__product-image">
                      <a href="${product.x_studio_url}">
                        <img
                          loading="lazy"
                          src="${product.x_studio_image_url}"
                          alt="${product.name}"
                        >
                      </a>
                    </div>
                    <div class="n8n-form__product-name">
                      <a href="${product.x_studio_url}">
                        ${product.name}
                      </a>
                    </div>
                  </div>
                `;
                formItems.append(itemElement);
              });
              
              formItems.classList.remove('hide');
            
            } else {
              formItems.classList.add('hide');
            }
            /* /Products */

            /* Fields */
            const formFields__wrapper = obj3.querySelector('.n8n-form__fields');
            formFields__wrapper.classList.add('hide');
            /* /Fields */
          });
        }
        /* /Form: Submit */
      }

      customElements.define('n8n-form', N8nForm);
    },
    
    sidebarFilters: class {
  
      constructor() {
        const obj = this;
  
        const eventName = 'theme:filters:refresh';
        const event = new Event(eventName);
          
        document.body.addEventListener(eventName, () => {
          const wrapper = document.querySelector('.collection-sidebar');
          
          if (wrapper) {
            const checkboxHeaders = wrapper.querySelectorAll('.widget-header--checkbox');
      
            if (checkboxHeaders) {
      
              for (var i = 0; i < checkboxHeaders.length; i++) {
                const checkboxHeader = checkboxHeaders[i];
      
                checkboxHeader.addEventListener('click', () => {
                  const filterValueCheckbox = checkboxHeader.parentNode.querySelector('li input[value="Y"]');
      
                  if (filterValueCheckbox) {
      
                    const filterValueLabel = filterValueCheckbox.nextElementSibling;
                    filterValueLabel.click();
                    
                    if (filterValueCheckbox.checked) {
                      checkboxHeader.classList.remove('widget-header--active');
                    }
                  }
                });
              }
            }
            
            const labels = wrapper.querySelectorAll('.widget-content ul > li > label');
      
            if (labels) {
      
              for (var i = 0; i < labels.length; i++) {
                const label = labels[i];
        
                label.addEventListener('click', () => {
                  const checkbox = label.previousElementSibling;
      
                  if (checkbox.checked) {
                    checkbox.checked = false;
                    
                  } else {
                    checkbox.checked = true;
                  }
      
                  obj.submit();
                });
              }
            }
            
            const clearLinks = wrapper.querySelectorAll('.widget-header h4 > a');
      
            if (clearLinks) {
      
              for (var i = 0; i < clearLinks.length; i++) {
                const clearLink = clearLinks[i];
        
                clearLink.addEventListener('click', () => {
                  const checkedCheckboxes = clearLink.parentNode.parentNode.nextElementSibling.querySelector('li > input[type="checkbox"]:checked');
      
                  if (checkedCheckboxes) {
      
                    for (var i = 0; i < checkedCheckboxes.length; i++) {
                      const checkedCheckbox = checkedCheckboxes[i];
                      checkedCheckbox.checked = false;
                    }
                  }
                  obj.submit();
                });
              }
            }
          }
        });
    
        document.body.dispatchEvent(event);
      }
  
      close() {
        window.document.querySelector('html').classList.remove('filter-open');
      }
  
      submit() {
        const obj = this;
        
        window.themeObj.sections.loader.show();
        obj.close();
        
        const url = obj.getLink();
        window.location.href = url;
      }
      
      getLink() {
        const obj = this;
        
        const wrapper = document.querySelector('.sidebar-filter');
        
        const clearUrl = wrapper.getAttribute('data-clear-url');
        var url = clearUrl;
        
        const filters = wrapper.querySelectorAll('.widget-content ul');
  
        const minPrice = document.getElementById('sidebar-filter--min-price');
        var minPriceValue = 0;
        
        const maxPrice = document.getElementById('sidebar-filter--max-price');
        var maxPriceValue = 0;
         
        if (filters) {
  
          for (var i = 0; i < filters.length; i++) {
            const filter = filters[i];
            const filterName = filter.getAttribute('data-name');
            const filterType = filter.getAttribute('data-type');
            
            const filterValues = filter.querySelectorAll('li');
  
            if (filterValues) {
  
              for (var i2 = 0; i2 < filterValues.length; i2++) {
                const filterValue = filterValues[i2];
                const filterCheckbox = filterValue.querySelector('input[type="checkbox"]');
  
                if (filterCheckbox.checked) {
  
                  if (filterType == 'price_range') {
                    const filterMinPrice = parseInt(filterCheckbox.getAttribute('data-min-price'));
                    const filterMaxPrice = parseInt(filterCheckbox.getAttribute('data-max-price'));
  
                    if (filterMinPrice <= minPriceValue || !minPriceValue) {
                      minPriceValue = filterMinPrice;
                    }
                    
                    if (filterMaxPrice >= maxPriceValue) {
                      maxPriceValue = filterMaxPrice;
                    }
                  
                  } else if (filterType == 'list') {
  
                    if (url.includes('?')) {
                      url += '&';
                      
                    } else {
                      url += '?';
                    }
                    
                    url += `${filterCheckbox.name}=${encodeURI(filterCheckbox.value)}`;
                  }
                }
              }
            }
  
            if (filterType == 'price_range' && minPriceValue && maxPriceValue) {
  
              if (url.includes('?')) {
                url += '&';
                
              } else {
                url += '?';
              }
  
              url += `${minPrice.getAttribute('data-name')}=${minPriceValue}&${maxPrice.getAttribute('data-name')}=${maxPriceValue}`;
            }
          }
        }
  
        return url;
      }
    }
  };
  
  document.addEventListener('DOMContentLoaded', () => {
    window.themeObj.init();
  });
  
})();
/* /vDEV */